module.exports = __webpack_public_path__ + "img/mujeres.5d3e7718.png";